import { Divider } from "@msuite/ui/divider";
import { getAbsenceCategoryIcon, Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { StatusIndicator } from "@msuite/ui/status-indicator";
import {
	getAbsenceCategoryTranslationKey,
	getAbsenceStateColor,
	getAbsenceStateTranslationKey,
} from "@msuite/utils/absences";
import { guardArray } from "@msuite/utils/array";
import { getColorByString } from "@msuite/utils/colors";
import { moment } from "@msuite/utils/date";
import type { AbsenceListItem } from "@msuite/utils/types";
import { Fragment } from "react";
import { AbsenceInboxCardControls } from "./absence-inbox-card-controls";

/** Props Interface */
interface AbsenceInboxCardProps {
	absence: Omit<AbsenceListItem, "consumedDays">;
	withControls?: boolean;
}

export function AbsenceInboxCard({ absence, withControls = true }: AbsenceInboxCardProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="card v-stack">
			<div className="h-stack justify-between">
				<div className="h-stack">
					<Icon
						name={getAbsenceCategoryIcon(absence.category)}
						color={`var(--color-${getColorByString(absence.category)}-500)`}
					/>
					<p className="label">{t(getAbsenceCategoryTranslationKey(absence.category))}</p>
				</div>
				<p className="label">{guardArray(absence.name)}</p>
			</div>
			<Divider variant="card" />
			<div className="h-stack justify-between">
				<p className="heading text-sm">{absence.userName}</p>
				<div className="h-stack">
					<StatusIndicator color={getAbsenceStateColor(absence.state)} />
					<p className="label">{t(getAbsenceStateTranslationKey(absence.state))}</p>
				</div>
			</div>
			<p className="label">{moment().getDateSpanString([absence.startDate, absence.endDate])}</p>
			{withControls && (
				<Fragment>
					<Divider variant="card" />
					<AbsenceInboxCardControls absence={absence} />
				</Fragment>
			)}
		</div>
	);
}
